import { useState, useEffect, useRef } from 'react'
import  axios  from 'axios'
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Modal } from 'bootstrap';
import { useToast } from '../../toastHook'
import { useFormik } from 'formik';
import { comparer } from '../../utils/comparer'
import { ConfirmModalComponent } from '../Utils/ConfirmModal'
import { Dropdown } from 'primereact/dropdown';
import * as Yup from 'yup';
import { errorCss } from '../Utils/formik-util';

export const CompetencePrincipaleComponent = () => {
    const modalRefInsert = useRef();
    const { display } = useToast();
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false);
    const [rows, setRows] = useState([]);
    const [competences, setCompetences] = useState([]);
    const [nbModifs, setNbModifs] = useState(0);

    const [activiteToInsert, setActiviteToInsert] = useState('');

    const [activiteToRemove, setActiviteToRemove] = useState('');
    const [competenceToRemove, setCompetenceToRemove] = useState('');

    useEffect(() => {
        axios.get('/api/competenceprincipale/getall')
            .then(response => {
                if (response.data) {

                    let tmpRows = [];

                    for (const key in response.data) {
                        const values = response.data[key];

                        const tmpValues = values.map(x => {
                            return {
                                key: key + '-' + x.competence,
                                data: {
                                    activite: key,
                                    competence: x
                                }
                            }
                        })

                        tmpRows.push({
                            key: key,
                            data: {
                                activite: key,
                                competence: ''
                            },
                            children: tmpValues
                        });
                    }

                    setRows(tmpRows);
                }
            });
    }, [nbModifs]);

    useEffect(() => {
        axios.get('/api/competences/get').then(response => {
            let tmpCompetences = response.data.map(x => { return { value: x } }
            );
            tmpCompetences.sort((x, y) => comparer(x.value, y.value));
            setCompetences(tmpCompetences)
        })
    }, []);

    const insertFormValidationSchema = Yup.object().shape({
        competence: Yup.string()
            .required('Requis')
            .oneOf(competences.map(x => x.value), 'compétence incorrecte')
    });

    const insertFormik = useFormik({
        initialValues: {
            competence: '',
            priorite: ''
        },
        validationSchema: insertFormValidationSchema,
        onSubmit: values => {

            const modal = Modal.getOrCreateInstance(modalRefInsert.current);
            modal.hide();

            axios.get('/api/competenceprincipale/add?activite=' + encodeURIComponent(activiteToInsert) + '&competence=' + encodeURIComponent(values.competence)).then(response => {
                if (response.status === 200) {

                    display({
                        titre: 'compétence principale a été ajoutée',
                        text: `la compétence principale '${values.competence}' a été ajoutée à l'activité ' ${activiteToRemove}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: 'compétence principale non ajoutée',
                        text: `la compétence principale '${values.competence}' n'a pas pu être ajoutée à l'activité ' ${activiteToRemove}`,
                        severity: 'danger'
                    })
                }
            });
        }
    });

    const removeCompetencePrincipale = () => {
        axios.get('/api/competenceprincipale/remove?activite=' + encodeURIComponent(  activiteToRemove ) + '&competence=' + encodeURIComponent(competenceToRemove )).then(response => {
            if (response.status === 200) {

                display({
                    titre: 'compétence principale retiré',
                    text: `la compétence principale '${competenceToRemove}' a été retiré à l'activité ' ${activiteToRemove}`,
                    severity: 'success'
                });

                setNbModifs(nbModifs + 1);
            }
            else {
                display({
                    titre: 'compétence principale non retiré',
                    text: `la compétence principale '${competenceToRemove}' n'a pas pu être retiré à l'activité ' ${activiteToRemove}`,
                    severity: 'danger'
                })
            }
        });
    }


    const templateButton = x => {
        if (x.data.competence) {
            return <div>
                <i className="pi pi-times-circle text-danger" onClick={() => {
                    setCompetenceToRemove(x.data.competence);
                    setActiviteToRemove(x.data.activite)

                    setOpenConfirmRemoveModal(true);
                }} ></i></div>
        }
        else {
            return <div><i className="pi pi-plus text-success" onClick={() => {
                setActiviteToInsert(x.data.activite);
                insertFormik.resetForm();
                const modal = Modal.getOrCreateInstance(modalRefInsert.current);
                modal.show();

            }}></i></div>
        }
    }


    return <div>
        <div className="alert alert-info">
            Voici la liste des compétences principales <br />
            Une compétence principale est une compétence pour laquelle l'expérience dans la compétence est calculé pour l'activité. Cette expérience donne alors un malus si elle est trop élevée et que la compétence est une compétence bloquante
        </div>
        <TreeTable value={rows} sortMode="multiple" >

            <Column field="activite" sortable header="Activité" filter expander></Column>

            <Column field="competence" sortable header="Compétence Principale" filter></Column>

            <Column body={templateButton} />

        </TreeTable>
        <div ref={modalRefInsert} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                                    <form onSubmit={insertFormik.handleSubmit}
                        >
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter une compétence liée</h5>
                    </div>
                    <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez ajouter une compétence liée à la compétence <b>{activiteToInsert}</b></div>
                            <div className="form-group">
                                <label htmlFor="competenceLiee">Compétence Liée</label>
                                {/*<Dropdown onChange={e => setCompetenceToInsert(e.value)}*/}
                                {/*    name="competenceLiee" value={competenceToInsert}  options={competences} optionLabel="value" optionValue="value" placeholder="Sélectionner une compétence"*/}
                            {/*    filter className={"form-control" } />*/}
                            <input list="competences-list" className={`form-select ${errorCss(insertFormik.errors.competence)}`} onChange={insertFormik.handleChange} value={insertFormik.values.competence} name="competence" />
                            <datalist id="competences-list">
                                {competences.map(x => <option key={x.value} value={x.value} />)}
                            </datalist>
                            </div>
                    </div>
                        <div className="modal-footer">
                        <button type="submit" className="btn btn-success"   >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                        </form>
                </div>
            </div>
            </div>
        <ConfirmModalComponent open={openConfirmRemoveModal} setOpen={setOpenConfirmRemoveModal} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer la competence principale '${competenceToRemove}' pour l'activité '${activiteToRemove}' , êtes-vous sure ? `} onConfirm={removeCompetencePrincipale} />

    </div>
}

